import { Box } from "@chakra-ui/react";
import React from "react";
import HoldingDetails from "../../../../components/holdings/HoldingDetails";
import { InvestmentDetailsSectionHeading } from "./InvestmentDetailsSectionHeading";

interface InvestmentDetailsHoldingDetailsProps {
  withDivider?: boolean;
  accountId: string;
  offeringId: string;
}
export const InvestmentDetailsHoldingDetails = ({
  accountId,
  offeringId,
}: InvestmentDetailsHoldingDetailsProps) => {
  return (
    <Box mt={5}>
      <InvestmentDetailsSectionHeading>
        Holdings
      </InvestmentDetailsSectionHeading>
      <HoldingDetails
        isDrawer={false}
        accountId={accountId}
        offeringId={offeringId}
        showHoldings
        showUnitizedInfo={false}
        showEditor={false}
      />
    </Box>
  );
};
